
export default function Services() {
  const services = [
    {
      icon: 'ri-home-smile-line',
      title: 'Purchase Guidance',
      description: 'Complete support from viewing to legal settlement for Granada and Costa del Sol real estate',
      features: [
        'Search & find service',
        'Financing application',
        'Extensive aftercare'
      ]
    },
    {
      icon: 'ri-building-line',
      title: 'Property Management',
      description: 'Professional property management services for your Granada and Costa del Sol investment',
      features: [
        'Carefree rental service',
        'Key transfer service',
        'Cleaning and maintenance'
      ]
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Business Consultancy',
      description: 'Expert real estate consultancy and business guidance',
      features: [
        'Computer consultancy',
        'Facilities management',
        'Business management advice'
      ]
    },
    {
      icon: 'ri-palette-line',
      title: 'Interior Design',
      description: 'Transform your Granada and Costa del Sol property with professional design',
      features: [
        'Graphic design services',
        'Space planning',
        'Complete interior solutions'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="font-['Playfair_Display'] text-5xl font-bold text-gray-900 mb-4">
            Our <strong>Real Estate Services</strong> Expertise
          </h3>
          <div className="w-16 h-1 bg-teal-600 mx-auto mb-4"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Comprehensive <strong>real estate services in Granada and Costa del Sol</strong> including <strong>property management</strong>, purchase guidance, and business consultancy tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <article 
              key={index}
              className="bg-gray-50 rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-600 rounded-full mb-6">
                <i className={`${service.icon} text-2xl text-white`} aria-hidden="true"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h4>
              <p className="text-sm text-gray-600 mb-4">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-0.5" aria-hidden="true"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
